import { Link } from "react-router-dom";
import { Hexagon, ArrowLeft } from "lucide-react";
import { Button } from "@/components/ui/button";
import { PolicyBody } from "@/lib/policyContent.jsx";

export default function Policy() {
  return (
    <div className="min-h-screen bg-stone-50" data-testid="policy-page">
      <header className="max-w-4xl mx-auto flex items-center justify-between px-6 py-5">
        <Link to="/" className="flex items-center gap-2" data-testid="policy-home-link">
          <div className="w-9 h-9 rounded-xl bg-yellow-400 grid place-items-center">
            <Hexagon className="w-5 h-5 text-amber-900" strokeWidth={2.5} />
          </div>
          <span className="font-display text-xl font-semibold tracking-tight">
            Hive <span className="text-yellow-500">@</span> Buzzzillion
          </span>
        </Link>
        <Link to="/">
          <Button variant="ghost" className="rounded-full" data-testid="policy-back-button">
            <ArrowLeft className="w-4 h-4 mr-2" /> Back
          </Button>
        </Link>
      </header>

      <main className="max-w-3xl mx-auto px-6 pb-20">
        <div className="text-xs font-semibold uppercase tracking-[0.2em] text-stone-500">Legal</div>
        <h1 className="font-display text-4xl sm:text-5xl font-light tracking-tight mt-2">
          Terms of Use & Content Policy
        </h1>
        <div className="mt-8 bg-white border border-stone-200 rounded-3xl p-6 sm:p-10">
          <PolicyBody />
        </div>
      </main>
    </div>
  );
}
